module.exports = require("new-module");


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-module3/index.js
 ** module id = 3
 ** module chunks = 0
 **/